import { render } from "./EventRankingScreen.vue?vue&type=template&id=6f6485a6&scoped=true&ts=true&lang=pug"
import script from "./EventRankingScreen.vue?vue&type=script&lang=ts"
export * from "./EventRankingScreen.vue?vue&type=script&lang=ts"

import "./EventRankingScreen.vue?vue&type=style&index=0&id=6f6485a6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6485a6"]])

export default __exports__